import { Form } from 'antd';
export default (function (decorated) {
    return Form.create()(decorated);
});



//////////////////
// WEBPACK FOOTER
// ./src/shared/decorators/form.ts
// module id = 58
// module chunks = 0